import { Entity } from '../../types';
import { elements } from '@ecosystem/newron-design-system';
import React, { ReactNode, useRef, useState } from 'react';
import { useOnOutsideClick } from '../../tools/outsideclick.hook';
import { SelectionMenu } from '../menus';
import { YColumnSelection } from './types';

type TitleProps = {
  title: string;
  selections?: YColumnSelection;
  children?: ReactNode;
};
function ChartTitle({ title, selections, children }: TitleProps) {
  const menuElement = useRef<HTMLDivElement>(null);
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  useOnOutsideClick(menuElement, () => setMenuOpen(false));

  const handleChange = (value: string) => {
    if (selections?.onChange) {
      selections.onChange(value);
    }
    setMenuOpen(false);
  };

  let columnOptions: Entity[] = selections?.options || [];

  const { Icon } = elements;

  return (
    <div className="flex items-center justify-center font-bold text-sm pb-4">
      {!selections && <span className="font-bold text-center">{title}</span>}
      {selections && (
        <div className="relative" ref={menuElement}>
          <button
            className="px-2 h-8 font-bold flex items-center gap-1 justify-start rounded border border-light"
            onClick={() => setMenuOpen(true)}
          >
            <span>{title}</span>
            <Icon color="brand">
              <Icon.icons.ChevronDown />
            </Icon>
          </button>
          <SelectionMenu
            onItemClick={handleChange}
            options={columnOptions}
            isOpen={menuOpen}
            value={selections.value}
          />
        </div>
      )}
      {children && children}
    </div>
  );
}

export { ChartTitle };
